// libs
import React, { memo } from 'react';

// constants
import { TEXTS, FOOTER_LINKS, INSTA_LINK, FB_LINK } from 'shared/components/Footer/constants';

// styles
import { Conatiner } from './styles';

//icons
import InstagramIcon from '@nykaa/ui-components/Icons/social-instagram-filled';
import FacebookIcon from '@nykaa/ui-components/Icons/social-facebook-filled';

function Links() {
  return (
    <Conatiner>
      <div className="lk-content">
        <div className="lk-section ipad-hide">
          <div className="lk-title">{TEXTS.WHO_WE_ARE}</div>
          <ul className="lk-list">
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.ABOUT_US}>
                {TEXTS.ABOUT_US}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.CAREERS}>
                {TEXTS.CAREERS}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.PRESS}>
                {TEXTS.PRESS}
              </a>
            </li>
          </ul>
        </div>

        <div className="lk-section lk-section-2">
          <div className="lk-title">{TEXTS.HELP}</div>
          <ul className="lk-list">
            <li className="lk-itm mobile-only">
              <a className="lk-anc" href={FOOTER_LINKS.ABOUT_US}>
                {TEXTS.ABOUT_US}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.SHIPPING}>
                {TEXTS.SHIPPING}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.HELP_CENTER}>
                {TEXTS.HELP_CENTER}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.TERMS} data-at="terms-conditions">
                {TEXTS.TERMS}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.IN_POLICY}>
                {TEXTS.IN_POLICY}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.RESPONSIBLE_DISCLOSURE}>
                {TEXTS.RESPONSIBLE_DISCLOSURE}
              </a>
            </li>
          </ul>
        </div>

        <div className="lk-section ipad-hide">
          <div className="lk-title">{TEXTS.QUICKLINKS}</div>
          <ul className="lk-list">
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.OFFERS}>
                {TEXTS.OFFERS}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.SITEMAP}>
                {TEXTS.SITEMAP}
              </a>
            </li>
            <li className="lk-itm">
              <a className="lk-anc" href={FOOTER_LINKS.STYLE_FILES}>
                {TEXTS.STYLE_FILES}
              </a>
            </li>
          </ul>
        </div>

        <div className="lk-section">
          <div className="lk-title">{TEXTS.FOLLOW_US}</div>
          <div className="lk-social">
            <a href={INSTA_LINK} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
            <a href={FB_LINK} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </a>
          </div>
        </div>
      </div>
    </Conatiner>
  );
}

export default memo(Links);
